import React from 'react';
/** @internal */
export var ModalTabContent = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "share-modal-body" },
        React.createElement("div", { className: "share-modal-header" },
            React.createElement("div", { className: "share-modal-content" }, children))));
};
//# sourceMappingURL=ModalTabContent.js.map